export const AHPUserField = ({ text, icon }) => {
  return (
    text && (
      <div className="ahp-user-info">
        <div className="ahp-icon">{icon}</div>
        {text}
      </div>
    )
  );
};
